import { api } from '@/shared/lib/api';
import type {
  OrdersResponse,
  OrdersQueryParams,
  OrderDetail,
  UpdateOrderStatusRequest,
  UpdateOrderStatusResponse,
  OrderHistoryResponse,
  OrderHistoryQueryParams,
  PurgeCompletedOrdersResponse,
} from '../types/orders.types';

const ORDERS = '/orders';

/* ---- List orders (panel) ---- */

/** Fila do painel; `channel` (`menu` ou `whatsapp`) filtra pelo canal do pedido. */
export async function getOrders(
  params: OrdersQueryParams = {},
): Promise<OrdersResponse> {
  const { data } = await api.get<OrdersResponse>(ORDERS, { params });
  return data;
}

/* ---- Order detail (panel) ---- */

export async function getOrder(id: string): Promise<OrderDetail> {
  const { data } = await api.get<OrderDetail>(`${ORDERS}/${id}`);
  return data;
}

/* ---- Update order status ---- */

export async function updateOrderStatus(
  id: string,
  request: UpdateOrderStatusRequest,
): Promise<UpdateOrderStatusResponse> {
  const { data } = await api.patch<UpdateOrderStatusResponse>(
    `${ORDERS}/${id}/status`,
    request,
  );
  return data;
}

/* ---- Order history ---- */

/**
 * Histórico; `channel` combina com a busca, o período e o status. A resposta
 * traz `availableChannels`, que decide se o filtro "Canal" aparece.
 */
export async function getOrderHistory(
  params: OrderHistoryQueryParams = {},
): Promise<OrderHistoryResponse> {
  const { data } = await api.get<OrderHistoryResponse>(`${ORDERS}/history`, {
    params,
  });
  return data;
}

/* ---- Purge completed orders ---- */

export async function purgeCompletedOrders(): Promise<PurgeCompletedOrdersResponse> {
  const { data } = await api.post<PurgeCompletedOrdersResponse>(
    `${ORDERS}/completed/purge`,
  );
  return data;
}
